<template>
  <v-container fluid>
    <gg-card>
      <gg-card-header>
        What to Expect
      </gg-card-header>
      <gg-card-text>
        <v-row>
          <v-col cols="12">
            <v-sheet>
              If you rather setup the account later manually, you can do so by skipping the Quick Launch Wizard.
              You can always re-launch this wizard by going to Hosting > {{ serviceDomain }} > and clicking
              the Manage button.
            </v-sheet>
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>

    <v-row class="pt-3">
      <v-col cols="12" class="text-center">
        <gg-btn tile color="primary" @click="exit" :loading="loading" class="ml-2">Skip & Exit</gg-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SkipThis',
  data () {
    return {
      loading: false,
    }
  },
  computed: mapGetters({
    service_id: 'wizard/service_id',
    serviceDomain: 'wizard/serviceDomain',
  }),
  methods: {
    ...mapActions({
      skipThis: 'wizard/skipThis',
    }),
    async exit () {
      this.loading = true
      await this.skipThis()
      this.loading = false
      await this.$router.push(`/hosting/shared/${this.service_id}`)
    },
  },
}
</script>
